var App = App || {};

App.VerticalTabs = (function ($) {
    "use strict";

    function Init(selector) {
        if (selector.length) {
            selector.each(function () {
                var $this = $(this),
                    $tabPanes = $this.find(".tab-pane"),
                    $select = $this.find("select");

                $(window).on("load resize orientationchange", function () {
                    updateSelect($tabPanes, $select);
                });

                updateSelect($tabPanes, $select);

                $select.on("change", function () {
                    var value = $select.val();

                    const triggerEl = document.querySelector('[data-bs-target="#' + value + '"]');
                    const tabInstance = bootstrap.Tab.getOrCreateInstance(triggerEl);

                    tabInstance.show();
                });
            });
        }
    }

    function updateSelect($tabPanes, $select) {
        $tabPanes.each(function () {
            var $this = $(this);

            if ($this.hasClass("active")) {
                var id = $this.attr("id");

                $select.val(id);
            }
        });
    }

    return {
        Init: Init
    };
})(jQuery);